import styled from 'styled-components';
// @ts-expect-error not typed
import SearchableCalleeList from 'calling-ui-library/callee-select/components/SearchableCalleeList';
// @ts-expect-error not typed

import { KOALA, OLAF } from 'HubStyleTokens/colors';
import CurrentSettingsInfoHelpDesk from './CurrentSettingsInfoHelpDesk';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallNotesButtonWrapper = styled.div.withConfig({
  displayName: "ThirdPartySettingsNumbersHelpDesk__CallNotesButtonWrapper",
  componentId: "sc-1ulqog4-0"
})(["position:sticky;bottom:0;background:", ";border-style:solid;border-width:2px 0 0 0;border-color:", ";"], OLAF, KOALA);
const CalleeSelectDropdownWrapper = styled.div.withConfig({
  displayName: "ThirdPartySettingsNumbersHelpDesk__CalleeSelectDropdownWrapper",
  componentId: "sc-1ulqog4-1"
})(["max-height:400px;overflow:auto;"]);
export const ThirdPartySettingsNumbersHelpDesk = props => {
  const {
    appIdentifier,
    calleesData,
    isKnownVisitor,
    visitorPhoneNumber,
    startOutboundCall,
    selectedCallProvider,
    onCallButtonClick
  } = props;
  return /*#__PURE__*/_jsxs(CalleeSelectDropdownWrapper, {
    children: [/*#__PURE__*/_jsx(SearchableCalleeList, {
      appIdentifier: appIdentifier,
      calleesData: calleesData || null,
      onSelectToNumber: startOutboundCall,
      disabled: false,
      canEdit: false,
      showAddPropertyButton: false,
      disabledTooltipMessage: null,
      isKnownVisitor: isKnownVisitor,
      visitorPhoneNumber: visitorPhoneNumber
    }), /*#__PURE__*/_jsx(CallNotesButtonWrapper, {
      children: /*#__PURE__*/_jsx(CurrentSettingsInfoHelpDesk, {
        disabled: false,
        selectedCallProvider: selectedCallProvider,
        onCallButtonClick: onCallButtonClick
      })
    })]
  });
};